<script setup lang="ts">
import { VDrawerDescription } from '~kui/vendor/vaul/drawer'
import { DialogDescription } from 'reka-ui'

import { useCredenzaContext } from './credenzaContext'

interface Props {
  asChild?: boolean;
}

withDefaults(defineProps<Props>(), {
  asChild: false,
})

const { isMobile } = useCredenzaContext()
const Comp = computed(() =>
  isMobile.value ? VDrawerDescription : DialogDescription,
)
</script>

<template>
  <component
    :is="Comp"
    :as-child="asChild"
    class="text-sm text-muted-foreground"
  >
    <slot />
  </component>
</template>
